import { FC } from 'react';
import { useStats, UseStatsProps } from 'react-instantsearch';

export const ArticlesResultsNumber: FC<UseStatsProps> = (props) => {
  const { nbHits } = useStats(props);

  return (
    <span
      className="sr-articles-hits"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: theme.locales.resultsLabel.replace('{{ quantity }}', String(nbHits)),
      }}
    />
  );
};
